/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useMemo } from 'react';
import { classNames } from '@src/utils';
import './app-header.scss';
var prefixCls = 'app-header';
export var AppHeader = function (props) {
    var className = useMemo(function () {
        return classNames(prefixCls, props.className);
    }, [props.className]);
    return (React.createElement("div", { className: "" + className },
        React.createElement("a", { href: "http://www.weimingedu.com/", target: "_blank", rel: "noreferrer", className: prefixCls + "_item " + prefixCls + "_logo" },
            React.createElement("img", { className: prefixCls + "_search_logo", src: require('../../assets/logo.png').default })),
        React.createElement("div", { className: prefixCls + "_item " + prefixCls + "_title" }, "\u667A\u6167\u2022\u4E3A\u660E"),
        React.createElement("div", { className: prefixCls + "_item " + prefixCls + "_children" }, props.children)));
};
export default React.memo(AppHeader);
